import orderBy from 'lodash/orderBy'
import isNil from 'lodash/isNil'

export const transportOrders = state => state.transportOrders

export const transportOrder = state => state.orderDetails && state.orderDetails.order

export const myTransportsFilters = state => state.transportOrders.filters

export const transportRequest = state =>
  state.orderDetails && state.orderDetails.transportRequest

export const transportMultiStop = state =>
  state.orderDetails && state.orderDetails.multiStop

export const canSubmitFiles = state => state.canSubmitFiles

export const podDocuments = state => orderBy(state.podDocuments, ['created'], ['desc'])

export const podDocumentsWithError = state =>
  state.podDocuments.filter(pod => pod.state === 'ERROR' || pod.state === 'REJECTED')

export const localPodDocuments = state =>
  state.podDocuments.filter(pod => isNil(pod.id) && pod.state !== 'UPLOADED')

export const getLocalPodDocument = state => localId =>
  state.podDocuments.find(pod => pod.localId === localId)

export const podProcessStatus = state => state.podProcessStatus

export const podInProgressTransition = state => state.podInProgressTransition

export const missingDocuments = state => state.missingDocuments

export const ableToUploadPodDocuments = state => state.ableToUploadPodDocuments

export const dispatchingConfirmation = state => state.dispatchingConfirmation
